import { buildR2AssetsImageUrl } from "@saas/shared/lib/image-url-builder";
import type { ByeByeTrendQualityId } from "./bye-bye-trend-preset";

export interface ByeByeTrendShowcaseClip {
	id: string;
	quality: ByeByeTrendQualityId;
	orientation: "portrait";
	onSite: boolean;
	duration: number;
	videoUrl: string;
	previewVideoUrl: string;
	poster: string;
	hasAudio: boolean;
	inputImages: string[];
}

const R2_BASE = "home/showcase/bye-bye-trend";

/**
 * 本页工作台出的 HD 样片，工作台与下方样片区共用同一份 720p 文件。10/31 下午换成 Seedance 2.5 编辑模式重出的 v2
 * （编辑模式成片 257 帧 = 10.72s），文件名带 -v2：同名覆盖会被边缘缓存住旧片。
 * 只放女生（右栏 Examples 第 1 条）：这个梗基本是女生在拍，男生版老公 10/31 撤了。
 * 上传完才往这里加，上传前请求过的地址会被边缘缓存 404
 */
const SPECS: { id: string; ref: string; duration: number }[] = [
	{ id: "hd-woman", ref: "woman", duration: 10.72 },
];

export const byeByeTrendShowcaseClips: ByeByeTrendShowcaseClip[] = SPECS.map(
	({ id, ref, duration }) => {
		const videoUrl = buildR2AssetsImageUrl(
			`${R2_BASE}/clips/${id}-720p-v2.mp4`,
		);
		return {
			id,
			quality: "hd",
			orientation: "portrait",
			onSite: true,
			duration,
			videoUrl,
			previewVideoUrl: videoUrl,
			poster: buildR2AssetsImageUrl(
				`${R2_BASE}/posters/${id}-720p-v2.jpg`,
			),
			hasAudio: true,
			inputImages: [buildR2AssetsImageUrl(`${R2_BASE}/refs/${ref}.jpg`)],
		};
	},
);

/**
 * 原 reel（@kayla_self 2026-10-04，取自 MakeViral 模板页，抓取 2026-10-31）：
 * 只放右栏 Examples 第 2 条，让人一眼认出梗；540×960 不到 720p，老公 10/31 同意例外。
 * 没有输入图，不出「Try this example」；onSite false，不进 VideoObject
 */
export const BYE_BYE_TREND_ORIGINAL_CLIP: ByeByeTrendShowcaseClip = {
	id: "original",
	quality: "hd",
	orientation: "portrait",
	onSite: false,
	duration: 11,
	videoUrl: buildR2AssetsImageUrl(`${R2_BASE}/clips/original.mp4`),
	previewVideoUrl: buildR2AssetsImageUrl(`${R2_BASE}/clips/original.mp4`),
	poster: buildR2AssetsImageUrl(`${R2_BASE}/posters/original.jpg`),
	hasAudio: true,
	inputImages: [],
};

/** 本页 HD 样片的正式上传日期，喂 VideoObject.uploadDate */
export const BYE_BYE_TREND_SHOWCASE_UPLOADED_AT = "2026-10-31T16:20:00+08:00";
